import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../../shared.module';
import { TranslocoModule } from '@ngneat/transloco';
import { UnsubscribeOnDestroyAdapter } from '../../../adapters/unsubscibe-on-destroy.adapter';
import { DialogService } from '../../../../services/dialog/dialog.service';

@Component({
  selector: 'psc-warning-dialog',
  standalone: true,
    imports: [CommonModule, SharedModule, TranslocoModule],
  templateUrl: './warning-dialog.component.html'
})
export class WarningDialogComponent extends UnsubscribeOnDestroyAdapter implements OnInit {

  warningText: string | undefined;
  showWarningDialog: boolean;


  constructor(
    private dialogService: DialogService,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.sink = this.dialogService.warningDialogObservable$.subscribe((warning) => {
      this.warningText = warning;
      this.showWarningDialog = true;
    });
  }
}
